import React, { useRef, useEffect, useState } from 'react';
import 'plyr/dist/plyr.css';

const VideoPlyr = ({ posterSrc, videoSrc }) => {
    const videoRef = useRef(null);
    const playerRef = useRef(null);
    const [Plyr, setPlyr] = useState(null);

    useEffect(() => {
        // Dynamically import Plyr only when component mounts
        import('plyr').then(module => {
            setPlyr(() => module.default || module);
        });
    }, []);

    useEffect(() => {
        if (videoRef.current && !playerRef.current && Plyr) {
            // Initialize Plyr
            playerRef.current = new Plyr(videoRef.current, {
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                fullscreen: { enabled: true, fallback: true, iosNative: true },
                autoplay: false,
            });
        }

        // Cleanup on unmount
        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
    }, [Plyr, posterSrc, videoSrc]);

    return (
        <div className="c-video-plyr">
            <video 
                ref={videoRef}
                poster={posterSrc}
                playsInline
                controls
            >
                <source src={videoSrc} type="video/mp4" />
            </video>
        </div>
    );
};

export default VideoPlyr;
